import { message } from 'antd';
import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const deleteMeasurement = async (id: number, refetch?: () => void) => {
  if (!id) return;

  try {
    const response = await deleteWithCSRF(envApiUrl + '/measurements/', {
      headers: {
        id,
      },
    });
    console.log('deleteMeasurement: response: ', response);
    message.success('Successfully deleted Measurement');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('deleteMeasurement error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to delete Measurement');
  }
};
